export const BASE_URL =
    process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
// export const BASE_URL = ''
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOAD_URL = '/api/upload';
export const CONTACT_US_URL = '/api/contactus';
export const CATEGORIES_URL = '/api/categories';
export const DISCOUNT_URL = '/api/discount';